import * as React from "react";
import { styled } from "@mui/system";
import MUICard from "@mui/material/Card";
import { CardProps } from "@mui/material/Card";

export const Card: (props: CardProps) => JSX.Element = styled(
  React.forwardRef<HTMLDivElement, CardProps>((props, ref) => (
    <MUICard ref={ref} {...props} />
  )),
  {
    name: "Card",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiPaper-root.MuiCard-root.MuiPaper-root": {
    background: theme.palette.primary.surfaceDefaultColor,
    boxShadow: theme.shadows[3]
  }
}));
